import Vue from 'vue';
import Component from 'vue-class-component';
import { convertTimeToDate, convertTo12HourFormat, getDayFromDate } from '@/utils/utilities';
import ProductPage from '@/models/product-page';
import TimeSchedulerModule from '@/stores/modules/time-scheduler';
import { getModule } from 'vuex-module-decorators';
import Product from '@/models/product';
import { Availabilities } from '@/utils/types';
import Settings, { SettingNamespace } from '@/utils/settings';
@Component
export default class Availability extends Vue {
    timeSchedulerModule!: TimeSchedulerModule;
    timeSlotSize = null;

    async created() {
        this.timeSchedulerModule = getModule(TimeSchedulerModule, this.$store);
        const settings = await Settings.getInstance();
        this.timeSlotSize = settings.get(SettingNamespace.ORDERS, 'time_slot_size')!.value;
    }

    get isAvailable() {
        return (schedule: any) => {
            if (!this.timeSchedulerModule.selectedTimeSlot) {
                return true;
            }
            const timeStart = convertTimeToDate(<string>schedule.timeRange.time_start);
            const timeEnd = convertTimeToDate(<string>schedule.timeRange.time_end);
            return this.timeSchedulerModule.selectedTimeSlot.start() >= timeStart && this.timeSchedulerModule.selectedTimeSlot.end() <= timeEnd;
        };
    }

    get isProductUnavailable() {
        return (product: Product) => {
            if (product.schedule && Object.keys(product.schedule).length > 0) {
                const todaySchedule = this.todaySchedule(product.schedule);
                if (todaySchedule) {
                    return !this.isAvailable(todaySchedule);
                }
                return false;
            }
        };
    }

    get isPageUnavailable() {
        return (page: ProductPage) => {
            if (page.schedule && Object.keys(page.schedule).length > 0) {
                const todaySchedule = this.todaySchedule(page.schedule);
                if (todaySchedule) {
                    return !this.isAvailable(todaySchedule);
                }
                return false;
            }
        };
    }

    get todaySchedule() {
        return (schedules: any) => {
            if (!this.timeSchedulerModule.selectedTimeSlot) {
                return false;
            }
            let todaySchedule = null;
            const today = getDayFromDate(this.timeSchedulerModule.selectedTimeSlot.start());
            for (let schedule of schedules) {
                const scheduleFound = schedule.days.find((day: string) => day === today);
                if (scheduleFound !== undefined) {
                    todaySchedule = schedule;
                    break;
                }
            }
            return todaySchedule;
        };
    }

    get scheduleText() {
        return (schedules: Availabilities) => {
            if (!this.timeSlotSize || !schedules || !this.timeSchedulerModule.selectedTimeSlot) {
                return '';
            }
            let todaySchedule = this.todaySchedule(schedules);
            if (todaySchedule) {
                const scheduleEnd = convertTimeToDate(<string>todaySchedule.timeRange.time_end);
                const timeEnd = new Date(scheduleEnd.getTime() - this.timeSlotSize! * 60 * 1000).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
                return this.isAvailable(todaySchedule) ? `Available until ${timeEnd}` : `Available from ${convertTo12HourFormat(todaySchedule.timeRange.time_start)} to ${timeEnd}`;
            }
            return '';
        };
    }
}
